<script lang="ts">

  import AdminView from "./components/admin/AdminView.svelte";
  import CaseList from "./components/CaseList.svelte";
  import Login from "./components/Login.svelte";
  import ToolBar from "./components/ToolBar.svelte";
  import { appState } from "./lib/Store";
  import type { IAppState } from "./types";

  let state: IAppState;
  appState.subscribe((s) => (state = s));
</script>

<section>
  <header><ToolBar /></header>
  <main>
    {#if state?.user != undefined}
      {#if state?.user?.type === "admin"}
        <AdminView />
      {:else}
        <CaseList on:select={(i) => {}} />
      {/if}
    {:else}
      <Login />
    {/if}
  </main>
  <footer><sub> © 2022 Paperfly</sub></footer>
</section>

<style>
  section {
    display: grid;
    width: 100%;
    height: 100%;
    grid-template:
      "head" 3rem
      "main"
      "foot" 30px;
  }

  header {
    grid-area: head;
    font-size: 0.8rem;
    justify-content: center;
    padding: 0;
    margin: 0;
    border-bottom: solid 1px lightgray;
    display: flex;
    justify-content: space-between;
    gap: 2rem;
  }

  main {
    height: 90%;
    grid-area: main;
    font-size: 0.8rem;
    padding: 0.5rem;
    overflow-y: auto;
  }

  footer {
    border-top: solid 1px lightgray;
    grid-area: foot;
    text-align: center;
    font-size: 0.8rem;
    padding: 0.5rem;
  }
</style>
